// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum NotificationsCounterChangedEvent {
    NewArr = 0,
    AddOne = 1,
    RemoveOne = 2
}
